import axios from 'axios'

export interface PostCorporateResourcesParams {
  project_id: number
  html: string
  reference_unit_id: string
}

export interface PostCorporateResourcesResponse {
  generation_id: number
  status: string
  reference_unit_id: string
}

export const postCorporateResources = async (
  params: PostCorporateResourcesParams
): Promise<PostCorporateResourcesResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const formData = new FormData()
    formData.append('project_id', params.project_id.toString())
    formData.append('html', params.html)
    formData.append('reference_unit_id', params.reference_unit_id)

    const response = await axios.post(
      `${backendUrl}/n8n/mavis/corporate/resources`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return (response.data as unknown) as PostCorporateResourcesResponse
  } catch (error) {
    console.error('postCorporateResources:', error)
    return null
  }
}
